import clsx from "clsx";
import { Button as RACButton, TooltipTrigger } from "react-aria-components";
import { TooltipBubble } from "../../tooltips/TooltipBubble";
import { buttonStyles } from "../Button/Button.recipe";
import styles from "./IconButton.module.css";
import { IconButtonProps } from "./types";

const IconButton = ({
  appearance,
  className,
  icon,
  label,
  tooltip = false,
  ...props
}: IconButtonProps) => {
  const button = (
    <RACButton
      {...props}
      className={clsx(
        buttonStyles({
          appearance,
          shape: "circle",
        }),
        styles.iconButtonBase,
        className,
      )}
      aria-label={label}
    >
      {icon}
    </RACButton>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <TooltipTrigger delay={100}>
      {button}
      <TooltipBubble>
        <span aria-hidden="true">{label}</span>
      </TooltipBubble>
    </TooltipTrigger>
  );
};

export default IconButton;
